import { ReactNode, Dispatch, SetStateAction } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { MultiSelectionContent } from './MultiSelectionContent';
import { MultiSelectionPickerContextProvider } from './MultiSelectionPickerContext';

const useStyles = makeStyles(
  theme => ({
    container: {
      border: `1px solid ${theme.palette.grey[300]}`,
      padding: theme.spacing(0.5),
      flex: 1,
      display: 'flex',
      overflow: 'hidden',
    },
  }),
  { name: 'PickerBox' },
);

export interface WbMultiSelectionPickerProps<T> {
  title?: string;
  selectedValues: T[];
  setSelectedValues: Dispatch<SetStateAction<T[]>>;
  setOpenParent?: Dispatch<SetStateAction<boolean>>;
  children: ReactNode;
  fetchAiData?: () => Promise<T[]>;
  contentHeader?: JSX.Element;
  contentHeight?: string;
  disableAll?: boolean;
  onChange?: (val: T[]) => void;
}

export function WbMultiSelectionPicker<T>(
  props: WbMultiSelectionPickerProps<T>,
) {
  const classes = useStyles();
  const {
    setOpenParent,
    selectedValues,
    setSelectedValues,
    children,
    title,
    fetchAiData,
    contentHeader,
    contentHeight,
    disableAll,
    onChange,
  } = props;

  return (
    <Box className={classes.container}>
      <Box>
        {title && (
          <Typography variant="h6" style={{ fontWeight: '500' }}>
            {title}
          </Typography>
        )}
      </Box>

      <MultiSelectionPickerContextProvider<T>
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        fetchAIData={fetchAiData}
        disableAll={disableAll}
        onChange={onChange}
      >
        <MultiSelectionContent
          title={title}
          setOpen={setOpenParent!}
          contentHeight={contentHeight}
          contentHeader={contentHeader}
          {...props}
        >
          {/* left content */}
          {children}
        </MultiSelectionContent>
      </MultiSelectionPickerContextProvider>
    </Box>
  );
}
